export const waitingFillerDefaults = Object.freeze({
  he: Object.freeze({
    standard: Object.freeze(['אז ככה..', 'אה..', 'אממ..', 'אה.. רגע..', 'בוא נראה..']),
    toolUse: Object.freeze(['אוקי רק רגע..'])
  }),
  en: Object.freeze({
    standard: Object.freeze(['Okay...', 'One moment,', 'Let me check that...', 'Hmm...']),
    toolUse: Object.freeze(['So,', 'Alright,'])
  }),
  es: Object.freeze({
    standard: Object.freeze(['Vale...', 'Déjame ver...', 'Mmm...']),
    toolUse: Object.freeze(['Entonces,', 'Un momento,'])
  }),
  it: Object.freeze({
    standard: Object.freeze(['Ok...', 'Vediamo...', 'Mmm...']),
    toolUse: Object.freeze(['Allora,', 'Un attimo,'])
  }),
  ar: Object.freeze({
    standard: Object.freeze(['تمام...', 'دعني أرى...', 'ممم...']),
    toolUse: Object.freeze(['إذن...', 'لحظة واحدة...'])
  })
});

function cloneSentenceList(valueParam) {
  const source = Array.isArray(valueParam) === true ? valueParam : [];
  const output = [];
  for (let index = 0; index < source.length; index = index + 1) {
    if (typeof source[index] === 'string') {
      output.push(source[index]);
    }
  }
  return output;
}

export function createDefaultWaitingFillerSentences() {
  const output = {};
  const languages = Object.keys(waitingFillerDefaults);
  for (let index = 0; index < languages.length; index = index + 1) {
    const language = languages[index];
    output[language] = {
      standard: cloneSentenceList(waitingFillerDefaults[language].standard),
      toolUse: cloneSentenceList(waitingFillerDefaults[language].toolUse)
    };
  }
  return output;
}

export function normalizeFillerLanguageCode(codeParam, nameParam) {
  const rawCode = typeof codeParam === 'string' ? codeParam.trim().toLowerCase() : '';
  const rawName = typeof nameParam === 'string' ? nameParam.trim().toLowerCase() : '';
  if (rawCode === 'iw' || rawCode === 'he' || rawName === 'hebrew' || rawName === 'עברית') {
    return 'he';
  }
  if (rawName === 'english') {
    return 'en';
  }
  if (rawName === 'spanish') {
    return 'es';
  }
  if (rawName === 'italian') {
    return 'it';
  }
  if (rawName === 'arabic' || rawName === 'عربي' || rawName === 'العربية') {
    return 'ar';
  }
  if (rawCode !== '') {
    return rawCode.substring(0, 2);
  }
  if (rawName !== '') {
    return rawName.substring(0, 2);
  }
  return '';
}

function resolveFillerLanguageCatalogEntry(entryParam) {
  if (typeof entryParam === 'string') {
    return { code: '', name: entryParam.trim() };
  }
  if (entryParam !== null && entryParam !== undefined && typeof entryParam === 'object' && Array.isArray(entryParam) !== true) {
    const name = typeof entryParam.name === 'string'
      ? entryParam.name
      : (typeof entryParam.label === 'string' ? entryParam.label : (typeof entryParam.text === 'string' ? entryParam.text : ''));
    const code = typeof entryParam.code === 'string'
      ? entryParam.code
      : (typeof entryParam.id === 'string' ? entryParam.id : (typeof entryParam.value === 'string' ? entryParam.value : ''));
    return { code: code, name: name };
  }
  return { code: '', name: '' };
}

export function buildFillerLanguageOptionsFromCatalog(catalogParam) {
  const output = [];
  const seen = new Set();
  const catalog = Array.isArray(catalogParam) === true ? catalogParam : [];
  for (let index = 0; index < catalog.length; index = index + 1) {
    const entry = resolveFillerLanguageCatalogEntry(catalog[index]);
    const code = normalizeFillerLanguageCode(entry.code, entry.name);
    if (code === '' || seen.has(code) === true) {
      continue;
    }
    seen.add(code);
    const name = typeof entry.name === 'string' && entry.name.trim() !== '' ? entry.name.trim() : code.toUpperCase();
    output.push({ code: code, name: name });
  }
  const defaultLanguages = Object.keys(waitingFillerDefaults);
  for (let index = 0; index < defaultLanguages.length; index = index + 1) {
    const code = defaultLanguages[index];
    if (seen.has(code) === true) {
      continue;
    }
    seen.add(code);
    output.push({ code: code, name: code.toUpperCase() });
  }
  return output;
}

export function normalizeWaitingFillerSentences(valueParam) {
  const source = valueParam !== null && valueParam !== undefined && typeof valueParam === 'object' && Array.isArray(valueParam) !== true ? valueParam : {};
  const output = createDefaultWaitingFillerSentences();
  const languages = Object.keys(source);
  for (let index = 0; index < languages.length; index = index + 1) {
    const language = languages[index].trim().toLowerCase().substring(0, 2);
    if (language === '') {
      continue;
    }
    const languageValue = source[languages[index]];
    if (languageValue === null || languageValue === undefined || typeof languageValue !== 'object' || Array.isArray(languageValue) === true) {
      continue;
    }
    if (output[language] === undefined) {
      output[language] = { standard: [], toolUse: [] };
    }
    if (Array.isArray(languageValue.standard) === true) {
      output[language].standard = cloneSentenceList(languageValue.standard);
    }
    if (Array.isArray(languageValue.toolUse) === true) {
      output[language].toolUse = cloneSentenceList(languageValue.toolUse);
    }
  }
  return output;
}
